import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';
import {getCourseDurationString} from '../../../../../utils/entity/course';
import {isDefined} from '../../../../../utils/typecheck';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, program, user} = contexts;

  const courseDates = getCourseDurationString(course);
  const hasCourseStartDate = isDefined(course?.start_date);

  const isIndividual = !!course?.client_id;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    subAvatar: user?.avatar,
    subAvatarPlaceholder: user?.name,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:membership_frozen.title.individual')
       * t('notifications:membership_frozen.title.group')
       * t('notifications:membership_unfrozen.title.individual')
       * t('notifications:membership_unfrozen.title.group')
       */
      i18n.t(
        `notifications:${event.type}.title.${
          isIndividual ? 'individual' : 'group'
        }`,
        {
          actorName:
            user?._id !== currentUserStore.user?._id
              ? user?.name
              : i18n.t('shared:label.your'),
          courseDates:
            hasCourseStartDate && courseDates ? `(${courseDates})` : '',
          programTitle: program?.title,
        },
      ),
  };
};
